import { alpha, Button, Typography } from "@mui/material";
import type { PimoReactComponent } from "@pimo/pimo-app-builder";
import { getLocalizedMessage, type SupportedLanguage } from "@pimo/pimo-l10n";

import { StatusPageLayout } from "./status-page-layout";

export type NotFoundPageEvent = "not-found:back" | "not-found:navigate";

export type NotFoundPageProps = {
  canViewPrograms?: boolean;
  language: SupportedLanguage;
};

export const NotFoundPage: PimoReactComponent<
  NotFoundPageProps,
  NotFoundPageEvent,
  { path: string }
> = ({ canViewPrograms = false, fireEvent, language }) => (
  <StatusPageLayout
    code="404"
    title={getLocalizedMessage(language, "notFound.title")}
    description={getLocalizedMessage(language, "notFound.description")}
    actions={
      <>
        {canViewPrograms && (
          <>
            <Button
              variant="contained"
              onClick={() =>
                fireEvent?.("not-found:navigate", { path: "/dashboard" })
              }
            >
              {getLocalizedMessage(language, "notFound.dashboard")}
            </Button>
            <Button
              variant="outlined"
              onClick={() =>
                fireEvent?.("not-found:navigate", { path: "/overview" })
              }
            >
              {getLocalizedMessage(language, "notFound.overview")}
            </Button>
          </>
        )}
        <Button
          variant={canViewPrograms ? "text" : "contained"}
          onClick={() => fireEvent?.("not-found:back")}
        >
          {getLocalizedMessage(language, "notFound.back")}
        </Button>
      </>
    }
  >
    <Typography
      component="div"
      sx={{
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.06),
        borderRadius: 999,
        color: "primary.main",
        fontSize: 13,
        maxWidth: "100%",
        overflowWrap: "anywhere",
        px: 1.75,
        py: 0.5,
        textAlign: "center",
      }}
    >
      {getLocalizedMessage(language, "notFound.requestedAddress")}:{" "}
      <code>{window.location.pathname}</code>
    </Typography>
  </StatusPageLayout>
);
